/**
 * Returns the most recent spike (anomaly) date from the list, or undefined when there are none.
 * Anomaly dates are ISO date strings, so lexicographic sorting matches chronological order.
 */
export const getMostRecentSpikeDate = (anomalyDates: string[] | undefined): string | undefined =>
    [...(anomalyDates ?? [])].sort().at(-1);
